import { render, staticRenderFns } from "./dialog-configuration-push.vue?vue&type=template&id=3186bbd0"
import script from "./dialog-configuration-push.vue?vue&type=script&lang=js"
export * from "./dialog-configuration-push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports